// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cCWiRJkHxDEep3 {
  position: fixed;
  z-index: 999;
  top: var(--ds-space-100, 8px);
  left: -9999px;
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-100, 4px);
  opacity: 0;
  background-color: var(--ds-surface-overlay, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0 8px 9pt #091e4226, 0 0 1px #091e424f);
  pointer-events: none;
}
.cCWiRJkHxDEep3:focus-visible {
  left: var(--ds-space-100, 8px);
  opacity: 1;
  pointer-events: auto;
}
.cCWiRJkHxDEep3:has(a:focus) {
  left: var(--ds-space-100, 8px);
  opacity: 1;
  pointer-events: auto;
}
.cCWiRJkHxDEep3 .MfPvVkBEe0kkz8 {
  font-weight: var(--ds-font-weight-bold, 700);
}
.cCWiRJkHxDEep3 a {
  text-decoration: underline;
}
`, ""]);
// Exports
export var skipNavigation = `cCWiRJkHxDEep3`;
export var skipNavigationText = `MfPvVkBEe0kkz8`;
export default ___CSS_LOADER_EXPORT___;
